import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import { NotFound } from '../NotFound/NotFound'

export type Props = {
  validateRoute?: (url: { match: any }) => boolean
  component?: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>
  url: { match: any }
}

export const ValidatedRoute = (props: Props) => {
  if (props.validateRoute && !props.validateRoute(props.url)) {
    return <NotFound />
  } else {
    return props.component ? React.createElement(props.component, props.url) : <NotFound />
  }
}
